import { TextInputProps } from '@utilitywarehouse/hearth-react';

import { MaskedInput } from '@components/form/MaskedInput';

type DoBFieldProps = {
  className: string;
  onChange(value: string): void;
} & Omit<TextInputProps, 'onChange'>;

const DoBField = ({ onChange, className, ...props }: DoBFieldProps) => (
  <MaskedInput
    className={className}
    placeholder="01/01/1991"
    mask="99/99/9999"
    onChange={onChange}
    autoComplete="bday"
    inputMode="numeric"
    {...props}
  />
);

export { DoBField };
